var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktokLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}"), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "linear-gradient",
    x1: -1.347,
    x2: 510.699,
    y1: 513.347,
    y2: 1.301
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#323232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "linear-gradient-2",
    x1: 153.06,
    x2: 368.112,
    y1: 376.967,
    y2: 161.914
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5053c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.233,
    stopColor: "#c90441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#f0014b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff004f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "linear-gradient-3",
    x1: 136.192,
    x2: 362.722,
    y1: 366.084,
    y2: 139.555
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b2c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#00c8d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#00e6e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f1ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "linear-gradient-4",
    x1: 9.279,
    x2: 510.704,
    y1: 506.873,
    y2: 5.448
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dde3e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcf7f7"
  })))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256,0C114.615,0,0,114.615,0,256S114.615,512,256,512,512,397.385,512,256,397.385,0,256,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M393.729,187.531a72.364,72.364,0,0,1-72.365-72.364h-51.7V317.615a43.964,43.964,0,1,1-31.547-42.221V225.138a93.308,93.308,0,1,0,80.839,92.477l1.5-102.332a123.5,123.5,0,0,0,73.267,23.946Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M380.062,173.448A72.364,72.364,0,0,1,307.7,101.083H256V303.531a43.964,43.964,0,1,1-31.547-42.22V211.054a93.308,93.308,0,1,0,80.839,92.477L306.8,201.2a123.5,123.5,0,0,0,73.267,23.945Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M380.062,186.237a72.365,72.365,0,0,1-44.615-28.176,72.346,72.346,0,0,1-26.375-42.894H269.667V317.615a44.015,44.015,0,0,1-81.653,22.815,44.018,44.018,0,0,1,36.439-79.119V224.328a93.3,93.3,0,0,0-72.236,150.841,93.3,93.3,0,0,0,153.075-71.638L306.8,201.2a123.5,123.5,0,0,0,73.267,23.945Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokLogo);
export default __webpack_public_path__ + "static/media/tiktok_logo.d59cd9a7.svg";
export { ForwardRef as ReactComponent };